var map = {
	"./CyberArticles/test-md-server.md": 2583,
	"./CyberGuides/test-md-server.md": 4557,
	"./CyberGuides/test.md": 4787,
	"./TechnologyNews/test.md": 4598,
	"./TroubleshootingGuides/test.md": 8922
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1985;